import { createSelector } from '@reduxjs/toolkit'

export const userRoleSelector = state => state.userRoleReducer

export const getUserRole = () =>
  createSelector(userRoleSelector, user => user.license || 'ANON')
